import React, { Component } from 'react'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { withStyles } from 'material-ui/styles'
import { graphql } from 'react-apollo'
import { GC_USER_ID } from '@/constants'
import 'react-table/react-table.css'
import { Paper, Tabs, Typography } from 'material-ui'
import { ALABASTER } from '@/constants'
import { READ_DATASETNAME } from '@/graphql/queries/dataset'
import FinaChartIncomeSpent from '@/components/ChartTypes/FinaChartIncomeSpent'
import FinaChartSpentBreakDown from '@/components/ChartTypes/FinaChartSpentBreakDown'
import FinaChartAccount from '@/components/ChartTypes/FinaChartAccount'
import FinaChartSpentFixCost from '@/components/ChartTypes/FinaChartSpentFixCost'
import FinaChartSpentFood from '@/components/ChartTypes/FinaChartSpentFood'
import FinaChartSpentShopping from '@/components/ChartTypes/FinaChartSpentShopping'
import FinaChartSpentOtherCost from '@/components/ChartTypes/FinaChartSpentOtherCost'

const styles = theme => ({
  root: {
    flexDirection: 'column',
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    overflow: 'hidden',
    backgroundColor: ALABASTER,
    width: '100%'
  },
  text: {
    textAlign: 'left',
    marginLeft:
      window.innerWidth < 630 * 1.2 ? 30 : (window.innerWidth - 630 * 1.2) / 2,
    marginRight:
      window.innerWidth < 630 * 1.2 ? 30 : (window.innerWidth - 630 * 1.2) / 2,
    color: 'grey',
    paddingBottom: 30
  },
  textInfo: {
    fontSize: 13,
    color: 'grey',
    opacity: 0.6
  },
  textNo: {
    textAlign: 'center',
    marginLeft:
      window.innerWidth < 630 * 1.2 ? 30 : (window.innerWidth - 630 * 1.2) / 2,
    marginRight:
      window.innerWidth < 630 * 1.2 ? 30 : (window.innerWidth - 630 * 1.2) / 2,
    color: 'grey'
  },
  textTitle: {
    textAlign: 'left',
    marginLeft:
      window.innerWidth < 630 * 1.2 ? 0 : (window.innerWidth - 630 * 1.2) / 2,
    marginRight:
      window.innerWidth < 630 * 1.2 ? 0 : (window.innerWidth - 630 * 1.2) / 2,
    color: 'grey'
  },
  body1: {
    color: 'grey',
    fontSize: 18
  },
  body1a: {
    color: 'grey',
    fontSize: 16
  },
  display1: {
    color: 'lightgrey',
    textAlign: 'left',
    padding: '30px'
  },
  label: {
    color: 'grey',
    textAlign: 'left',
    padding: '30px'
  },
  Subheading: {
    color: 'grey',
    textAlign: 'left',
    paddingLeft: '30px',
    fontSize: 20
  },
  textStatus: {
    fontSize: 13,
    color: 'grey',
    textAlign: 'right',
    paddingRight: '30px',
    opacity: 0.6
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120
  },
  chart: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: ALABASTER,
    width: '100%'
  },
  paper: {
    textAlign: 'center',
    color: theme.palette.text.secondary,
    width: window.innerWidth < 630 * 1.2 ? window.innerWidth : 630 * 1.2,
    height:
      window.innerWidth < 630 * 1.2 ? window.innerWidth * 0.76 : 480 * 1.2,
    marginBottom: 30
  },
  paperLong: {
    textAlign: 'center',
    color: theme.palette.text.secondary,
    width: window.innerWidth < 630 * 1.2 ? window.innerWidth : 630 * 1.2,
    height: window.innerWidth < 630 * 1.2 ? window.innerWidth * 1.5 : 480 * 1.8,
    marginBottom: 30
  },
  paperTitle: { paddingTop: 30 },
  paperMini: {
    textAlign: 'center',
    color: theme.palette.text.secondary,
    width: window.innerWidth,
    height: window.innerWidth * 2.8 * 16 / 21,
    marginBottom: 30
  },
  table: {
    margin: 5
  },
  tableCentre: {
    display: 'flex',
    justifyContent: 'center',
    overflow: 'auto'
  },
  tableWrapper: {
    display: 'flex',
    justifyContent: 'left',
    overflow: 'auto',
    marginBottom: 20
  },
  tableCell: {
    textAlign: 'center'
  },
  modalHealder: {
    margin: window.innerHeight * 0.03
  },
  modalContent: {
    margin: window.innerHeight * 0.008
  },
  chartWrapper: {},
  toolbar: {
    backgroundColor: ALABASTER,
    color: 'white',
    height: 0
  },
  tableroot: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto'
  },
  bottomButtoms: {
    width: '100%',
    display: 'flex',
    justifyContent: 'right'
  }
})

@graphql(READ_DATASETNAME, {
  name: 'readExpenseDefault',
  options: ({ match }) => ({
    variables: {
      dataName: 'defaultExpense',
      userId: global.localStorage.getItem(GC_USER_ID)
    }
  })
})
@withStyles(styles)
export default class AlchemyExpense extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: props.width,
      weekNo: moment()
        .week()
        .toString(),
      selected: [],
      open: false,
      cell: [],
      hours: '',
      timeStart: '',
      timeEnd: '',
      comment: '',
      emoji: '',
      productivity: ''
    }
  }

  updateDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  componentDidMount() {
    this.updateDimensions()
    window.addEventListener('resize', this.updateDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions)
  }

  render() {
    const { classes } = this.props
    const userId = global.localStorage.getItem(GC_USER_ID)

    if (this.props.readExpenseDefault.loading) {
      return <div>Loading reading data ... </div>
    }

    if (this.props.readExpenseDefault.allDataSets.length === 0) {
      return <div>no data yet</div>
    }

    return (
      <div>
        {userId === this.props.readExpenseDefault.allDataSets[0].author.id ? (
          <div style={{ width: '100%' }}>
            <div className={classes.root}>
              {this.props.readExpenseDefault.allDataSets.map(
                e =>
                  e.name === 'defaultExpense income vs spent' ? (
                    <div key={e.name}>
                      <div className={classes.textTitle}>
                        <Paper className={classes.paperTitle} elevation={0}>
                          <Typography
                            variant="display1"
                            className={classes.display1}
                          >
                            {e.description}
                          </Typography>
                          <Typography
                            variant="subheading"
                            className={classes.Subheading}
                          >
                            A little bit more than{' '}
                            <span style={{ color: 'red' }}>1K</span> every
                            month.
                          </Typography>
                          <Typography
                            variant="body1"
                            className={classes.textStatus}
                          >
                            Updated: {moment(e.updatedAt).fromNow()} <br /> On{' '}
                            {moment(e.updatedAt).format('ddd, MMM Do')}
                          </Typography>
                        </Paper>
                      </div>

                      <div className={classes.chart}>
                        <Paper className={classes.paper} elevation={0}>
                          <FinaChartIncomeSpent
                            data={e.dataPoints}
                            width={
                              window.innerWidth < 630 * 1.2
                                ? window.innerWidth
                                : 630 * 1.2
                            }
                            height={
                              window.innerWidth < 630 * 1.2
                                ? window.innerWidth * 0.76
                                : 480 * 1.2
                            }
                          />
                        </Paper>
                      </div>

                      <div className={classes.text}>
                        <Typography
                          variant="caption"
                          className={classes.body1a}
                        >
                          <div className={classes.textInfo}>
                            <b>Dataset Information:</b> <br />
                            <ul>
                              <li>Dataset name: {e.name}</li>
                              <li>
                                Dateset:{' '}
                                <Link to={`../datasets/${e.id}`}> link </Link>
                              </li>
                              <li>Author: {e.author.name}</li>
                              <li>
                                Created at: {moment(e.createdAt).calendar()}
                              </li>
                              <li>
                                Updated at: {moment(e.updatedAt).fromNow()}
                              </li>
                            </ul>
                          </div>
                        </Typography>
                      </div>
                    </div>
                  ) : (
                    ''
                  )
              )}

              {this.props.readExpenseDefault.allDataSets.map(
                e =>
                  e.name === 'defaultExpense spent break down' ? (
                    <div key={e.name}>
                      <div className={classes.textTitle}>
                        <Paper className={classes.paperTitle} elevation={0}>
                          <Typography
                            variant="display1"
                            className={classes.display1}
                          >
                            {e.description}
                          </Typography>
                          <Typography
                            variant="subheading"
                            className={classes.Subheading}
                          >
                            <span style={{ color: 'orange' }}>●</span> Food{' '}
                            <span style={{ color: 'lightblue' }}>●</span>{' '}
                            Shopping{' '}
                            <span style={{ color: 'lightgrey' }}>●</span> Fix
                            Cost <span style={{ color: 'pink' }}>●</span> Other
                            Cost
                          </Typography>
                          <Typography
                            variant="body1"
                            className={classes.textStatus}
                          >
                            Updated: {moment(e.updatedAt).fromNow()} <br /> On{' '}
                            {moment(e.updatedAt).format('ddd, MMM Do')}
                          </Typography>
                        </Paper>
                      </div>

                      <div className={classes.chart}>
                        <Paper className={classes.paper} elevation={0}>
                          <FinaChartSpentBreakDown
                            data={e.dataPoints}
                            width={
                              window.innerWidth < 630 * 1.2
                                ? window.innerWidth
                                : 630 * 1.2
                            }
                            height={
                              window.innerWidth < 630 * 1.2
                                ? window.innerWidth * 0.76
                                : 480 * 1.2
                            }
                          />
                        </Paper>
                      </div>

                      <div className={classes.text}>
                        <Typography
                          variant="caption"
                          className={classes.body1a}
                        >
                          <div className={classes.textInfo}>
                            <b>Dataset Information:</b> <br />
                            <ul>
                              <li>Dataset name: {e.name}</li>
                              <li>
                                Dateset:{' '}
                                <Link to={`../datasets/${e.id}`}> link </Link>
                              </li>
                              <li>Author: {e.author.name}</li>
                              <li>
                                Created at: {moment(e.createdAt).calendar()}
                              </li>
                              <li>
                                Updated at: {moment(e.updatedAt).fromNow()}
                              </li>
                            </ul>
                          </div>
                        </Typography>
                      </div>
                    </div>
                  ) : (
                    ''
                  )
              )}

              {this.props.readExpenseDefault.allDataSets.map(
                e =>
                  e.name === 'defaultExpense fix cost' ? (
                    <div key={e.name}>
                      <div className={classes.textTitle}>
                        <Paper className={classes.paperTitle} elevation={0}>
                          <Typography
                            variant="display1"
                            className={classes.display1}
                          >
                            {e.description}
                          </Typography>
                          <Typography
                            variant="subheading"
                            className={classes.Subheading}
                          >
                            <span style={{ color: 'pink' }}>3.5K</span> every
                            month on rent, student loan, gym and utility,{' '}
                            <span style={{ color: 'lightgreen' }}>700</span>{' '}
                            left over.
                          </Typography>
                          <Typography
                            variant="body1"
                            className={classes.textStatus}
                          >
                            Updated: {moment(e.updatedAt).fromNow()} <br /> On{' '}
                            {moment(e.updatedAt).format('ddd, MMM Do')}
                          </Typography>
                        </Paper>
                      </div>

                      <div className={classes.chart}>
                        <Paper className={classes.paper} elevation={0}>
                          <FinaChartSpentFixCost
                            data={e.dataPoints}
                            width={
                              window.innerWidth < 630 * 1.2
                                ? window.innerWidth
                                : 630 * 1.2
                            }
                            height={
                              window.innerWidth < 630 * 1.2
                                ? window.innerWidth * 0.76
                                : 480 * 1.2
                            }
                          />
                        </Paper>
                      </div>

                      <div className={classes.text}>
                        <Typography
                          variant="caption"
                          className={classes.body1a}
                        >
                          <div className={classes.textInfo}>
                            <b>Dataset Information:</b> <br />
                            <ul>
                              <li>Dataset name: {e.name}</li>
                              <li>
                                Dateset:{' '}
                                <Link to={`../datasets/${e.id}`}> link </Link>
                              </li>
                              <li>Author: {e.author.name}</li>
                              <li>
                                Created at: {moment(e.createdAt).calendar()}
                              </li>
                              <li>
                                Updated at: {moment(e.updatedAt).fromNow()}
                              </li>
                            </ul>
                          </div>
                        </Typography>
                      </div>
                    </div>
                  ) : (
                    ''
                  )
              )}

              {this.props.readExpenseDefault.allDataSets.map(
                e =>
                  e.name === 'defaultExpense food cost' ? (
                    <div key={e.name}>
                      <div className={classes.textTitle}>
                        <Paper className={classes.paperTitle} elevation={0}>
                          <Typography
                            variant="display1"
                            className={classes.display1}
                          >
                            {e.description}
                          </Typography>
                          <Typography
                            variant="subheading"
                            className={classes.Subheading}
                          >
                            Is $600 a good goal for food every month?
                          </Typography>
                          <br />
                          <Typography
                            variant="subheading"
                            className={classes.label}
                          >
                            <span style={{ color: 'orange', opacity: 0.5 }}>
                              ●
                            </span>{' '}
                            Eat Out{' '}
                            <span style={{ color: 'purple', opacity: 0.5 }}>
                              ●
                            </span>{' '}
                            Grocery
                          </Typography>
                          <Typography
                            variant="body1"
                            className={classes.textStatus}
                          >
                            Updated: {moment(e.updatedAt).fromNow()} <br /> On{' '}
                            {moment(e.updatedAt).format('ddd, MMM Do')}
                          </Typography>
                        </Paper>
                      </div>

                      <div className={classes.chart}>
                        <Paper className={classes.paper} elevation={0}>
                          <FinaChartSpentFood
                            data={e.dataPoints}
                            width={
                              window.innerWidth < 630 * 1.2
                                ? window.innerWidth
                                : 630 * 1.2
                            }
                            height={
                              window.innerWidth < 630 * 1.2
                                ? window.innerWidth * 0.76
                                : 480 * 1.2
                            }
                          />
                        </Paper>
                      </div>

                      <div className={classes.text}>
                        <Typography
                          variant="caption"
                          className={classes.body1a}
                        >
                          <div className={classes.textInfo}>
                            <b>Dataset Information:</b> <br />
                            <ul>
                              <li>Dataset name: {e.name}</li>
                              <li>
                                Dateset:{' '}
                                <Link to={`../datasets/${e.id}`}> link </Link>
                              </li>
                              <li>Author: {e.author.name}</li>
                              <li>
                                Created at: {moment(e.createdAt).calendar()}
                              </li>
                              <li>
                                Updated at: {moment(e.updatedAt).fromNow()}
                              </li>
                            </ul>
                          </div>
                        </Typography>
                      </div>
                    </div>
                  ) : (
                    ''
                  )
              )}

              {this.props.readExpenseDefault.allDataSets.map(
                e =>
                  e.name === 'defaultExpense shopping cost' ? (
                    <div key={e.name}>
                      <div className={classes.textTitle}>
                        <Paper className={classes.paperTitle} elevation={0}>
                          <Typography
                            variant="display1"
                            className={classes.display1}
                          >
                            {e.description}
                          </Typography>
                          <Typography
                            variant="subheading"
                            className={classes.Subheading}
                          >
                            Is $100 a good goal for shopping every month?
                          </Typography>
                          <br />
                          <Typography
                            variant="subheading"
                            className={classes.label}
                          >
                            <span style={{ color: 'blue' }}>●</span> Shopping{' '}
                            <span style={{ color: 'blue', opacity: 0.2 }}>
                              ●
                            </span>{' '}
                            Return
                          </Typography>
                          <Typography
                            variant="body1"
                            className={classes.textStatus}
                          >
                            Updated: {moment(e.updatedAt).fromNow()} <br /> On{' '}
                            {moment(e.updatedAt).format('ddd, MMM Do')}
                          </Typography>
                        </Paper>
                      </div>

                      <div className={classes.chart}>
                        <Paper className={classes.paper} elevation={0}>
                          <FinaChartSpentShopping
                            data={e.dataPoints}
                            width={
                              window.innerWidth < 630 * 1.2
                                ? window.innerWidth
                                : 630 * 1.2
                            }
                            height={
                              window.innerWidth < 630 * 1.2
                                ? window.innerWidth * 0.76
                                : 480 * 1.2
                            }
                          />
                        </Paper>
                      </div>

                      <div className={classes.text}>
                        <Typography
                          variant="caption"
                          className={classes.body1a}
                        >
                          <div className={classes.textInfo}>
                            <b>Dataset Information:</b> <br />
                            <ul>
                              <li>Dataset name: {e.name}</li>
                              <li>
                                Dateset:{' '}
                                <Link to={`../datasets/${e.id}`}> link </Link>
                              </li>
                              <li>Author: {e.author.name}</li>
                              <li>
                                Created at: {moment(e.createdAt).calendar()}
                              </li>
                              <li>
                                Updated at: {moment(e.updatedAt).fromNow()}
                              </li>
                            </ul>
                          </div>
                        </Typography>
                      </div>
                    </div>
                  ) : (
                    ''
                  )
              )}

              {this.props.readExpenseDefault.allDataSets.map(
                e =>
                  e.name === 'defaultExpense other cost' ? (
                    <div key={e.name}>
                      <div className={classes.textTitle}>
                        <Paper className={classes.paperTitle} elevation={0}>
                          <Typography
                            variant="display1"
                            className={classes.display1}
                          >
                            {e.description}
                          </Typography>
                          <Typography
                            variant="subheading"
                            className={classes.Subheading}
                          >
                            Travel, Taxi, Gas, Tax ...
                          </Typography>
                          <Typography
                            variant="body1"
                            className={classes.textStatus}
                          >
                            Updated: {moment(e.updatedAt).fromNow()} <br /> On{' '}
                            {moment(e.updatedAt).format('ddd, MMM Do')}
                          </Typography>
                        </Paper>
                      </div>

                      <div className={classes.chart}>
                        <Paper className={classes.paper} elevation={0}>
                          <FinaChartSpentOtherCost
                            data={e.dataPoints}
                            width={
                              window.innerWidth < 630 * 1.2
                                ? window.innerWidth
                                : 630 * 1.2
                            }
                            height={
                              window.innerWidth < 630 * 1.2
                                ? window.innerWidth * 0.76
                                : 480 * 1.2
                            }
                          />
                        </Paper>
                      </div>

                      <div className={classes.text}>
                        <Typography
                          variant="caption"
                          className={classes.body1a}
                        >
                          <div className={classes.textInfo}>
                            <b>Dataset Information:</b> <br />
                            <ul>
                              <li>Dataset name: {e.name}</li>
                              <li>
                                Dateset:{' '}
                                <Link to={`../datasets/${e.id}`}> link </Link>
                              </li>
                              <li>Author: {e.author.name}</li>
                              <li>
                                Created at: {moment(e.createdAt).calendar()}
                              </li>
                              <li>
                                Updated at: {moment(e.updatedAt).fromNow()}
                              </li>
                            </ul>
                          </div>
                        </Typography>
                      </div>
                    </div>
                  ) : (
                    ''
                  )
              )}

              {this.props.readExpenseDefault.allDataSets.map(
                e =>
                  e.name === 'defaultExpense accounts data' ? (
                    <div key={e.name}>
                      <div className={classes.textTitle}>
                        <Paper className={classes.paperTitle} elevation={0}>
                          <Typography
                            variant="display1"
                            className={classes.display1}
                          >
                            {e.description}
                          </Typography>
                          <Typography
                            variant="body1"
                            className={classes.textStatus}
                          >
                            Updated: {moment(e.updatedAt).fromNow()} <br /> On{' '}
                            {moment(e.updatedAt).format('ddd, MMM Do')}
                          </Typography>
                        </Paper>
                      </div>

                      <div className={classes.chart}>
                        <Paper className={classes.paperLong} elevation={0}>
                          <FinaChartAccount
                            data={e.dataPoints}
                            width={
                              window.innerWidth < 630 * 1.2
                                ? window.innerWidth
                                : 630 * 1.2
                            }
                            height={
                              window.innerWidth < 630 * 1.2
                                ? window.innerWidth * 0.76
                                : 480 * 1.2
                            }
                          />
                        </Paper>
                      </div>

                      <div className={classes.text}>
                        <Typography
                          variant="caption"
                          className={classes.body1a}
                        >
                          <div className={classes.textInfo}>
                            <b>Dataset Information:</b> <br />
                            <ul>
                              <li>Dataset name: {e.name}</li>
                              <li>
                                Dateset:{' '}
                                <Link to={`../datasets/${e.id}`}> link </Link>
                              </li>
                              <li>Author: {e.author.name}</li>
                              <li>
                                Created at: {moment(e.createdAt).calendar()}
                              </li>
                              <li>
                                Updated at: {moment(e.updatedAt).fromNow()}
                              </li>
                            </ul>
                          </div>
                        </Typography>
                      </div>
                    </div>
                  ) : (
                    ''
                  )
              )}
            </div>
          </div>
        ) : (
          <div style={{ width: '100%', height: window.innerHeight }}>
            <Tabs className={classes.toolbar} centered />
            <div className={classes.root}>
              <div className={classes.textNo}>
                <img alt="" src="https://i.gifer.com/6lB.gif" />
                <Typography variant="display1">
                  <br /> Permision required <br />
                  <br />
                </Typography>
                <Typography variant="body1" className={classes.body1}>
                  This is a private data story, please submit request to author
                  for permission.
                  <br />
                </Typography>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/alchemy/expense.js